import './Body.css';
import React from "react";
import Footer from './Footer';
import { Link } from 'react-router-dom';
import printableList from './printables/printableList.js'


function Printables(props) {
    return (
        <div className="">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="storyHeaderText"> FREE PRINTABLES </h1>
            <div className="storyListRow">
            {printableList.map((printable, index) => ( 
                <div key={index} className="storyPreviewBox">
                    <img src={printable.src} alt={printable.alt} />
                    <h1 className="storyPreviewTitle"> {printable.title}</h1>
                </div>
            ))}
            </div>
            <Footer/>
        </div>
    )
}

export default Printables;